import { logoBlack, logoWhite } from 'components/common/whitelabel';
import React from 'react';

function Logo({ white = false, ...rest }) {
  const src = white ? logoWhite : logoBlack;
  return <img src={src} alt="" {...rest} />;
}

export default Logo;
